// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"55cc4cfb","456":"0267c773","656":"2eb535e8","756":"193e1d02","968":"ec55dff9"}[chunkId] + ".chunk.js";
};